import AutomationSection from "../components/AutomationSection/AutomationSection";
import WebDesignSection from "../components/WebDesignSection/WebDesignSection";

export default function Services() {
  return (
    <div style={{ background: "#0a0a0a", color: "white" }}>
      <AutomationSection />
      <WebDesignSection />
    </div>
  );
}
